import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { GetAction } from './GetAction'
import {
  DEFAULT_HEADER_MENU,
  isExternalUrl,
  menuHref,
  mergeMenuWithCmsPages,
  pagesToMenuItems,
} from '../utils/pageMenu'
import { canAccessManage } from '../manage/auth'

const DEFAULT_WEBSITE_NAME = 'श्री आचार्य विद्यासागर जीवदया ट्रस्ट'

function NavMenuLink({ item, className, style }) {
  const href = menuHref(item.url)
  if (isExternalUrl(href) || Number(item.open_new_tab) === 1) {
    return (
      <a
        className={className}
        style={style}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
      >
        {item.label}
      </a>
    )
  }
  return (
    <Link className={className} style={style} to={href}>
      {item.label}
    </Link>
  )
}

function Header() {
  let history = useHistory()
  const [websiteName, setWebsiteName] = useState(DEFAULT_WEBSITE_NAME)
  const [menuItems, setMenuItems] = useState(null)
  const [showManage, setShowManage] = useState(false)

  useEffect(() => {
    setShowManage(canAccessManage())
    GetAction('get', {}, 'settings/get').then((data) => {
      if (data?.status === 'success' && data.response?.website_name) {
        setWebsiteName(data.response.website_name)
      }
    })

    let cancelled = false
    ;(async () => {
      const [menuData, pagesData] = await Promise.all([
        GetAction('get', { location: 'header' }, 'menu/list'),
        GetAction('get', { menu_location: 'header' }, 'pages/pagesList'),
      ])
      if (cancelled) return

      const pages =
        pagesData?.status === 'success' && Array.isArray(pagesData.response)
          ? pagesData.response
          : []

      // Prefer Manage → Menus, but always surface Active CMS header pages too
      if (
        menuData?.status === 'success' &&
        Array.isArray(menuData.response) &&
        menuData.response.length > 0
      ) {
        setMenuItems(mergeMenuWithCmsPages(menuData.response, pages))
        return
      }

      // Fallback: CMS pages + hardcoded links (previous behaviour)
      const pageItems = pagesToMenuItems(pages)
      const defaults = [...DEFAULT_HEADER_MENU]
      const home = defaults[0]
      const rest = defaults.slice(1)
      setMenuItems([home, ...pageItems, ...rest])
    })()

    return () => {
      cancelled = true
    }
  }, [])

  const logout = () => {
    sessionStorage.clear()
    history.push('/Login')
  }

  const navLinkClass = 'nav-link header-nav-link'
  const navLinkStyle = { color: '#fff' }
  const links = menuItems || DEFAULT_HEADER_MENU

  return (
    <nav className="navbar navbar-expand-md navbar-dark header">
      <Link className="navbar-brand websitename" to="/" style={navLinkStyle}>
        <b>{websiteName}</b>
      </Link>
      <button
        className="navbar-toggler header-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarCollapse"
        aria-controls="navbarCollapse"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="header-toggler-bar" />
        <span className="header-toggler-bar" />
        <span className="header-toggler-bar" />
      </button>
      <div className="collapse navbar-collapse header-nav-collapse" id="navbarCollapse">
        <ul className="navbar-nav ml-auto header-nav">
          {links.map((item, idx) => (
            <li className="nav-item" key={`${item.url}-${idx}`}>
              <NavMenuLink item={item} className={navLinkClass} style={navLinkStyle} />
            </li>
          ))}

          {sessionStorage.id ? (
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle header-nav-link header-user-toggle"
                href="#"
                role="button"
                data-toggle="dropdown"
                aria-expanded="false"
                style={navLinkStyle}
              >
                {sessionStorage.name}
              </a>
              <ul className="dropdown-menu header-dropdown-menu">
                <li>
                  <Link className="dropdown-item" to="/Profile">
                    Profile
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/DonationHistory">
                    Donation History
                  </Link>
                </li>
                {showManage ? (
                  <li>
                    <Link className="dropdown-item" to="/manage">
                      Manage
                    </Link>
                  </li>
                ) : null}
                <li>
                  <hr className="dropdown-divider" />
                </li>
                <li>
                  <button
                    type="button"
                    className="dropdown-item header-logout-btn"
                    onClick={logout}
                  >
                    Logout
                  </button>
                </li>
              </ul>
            </li>
          ) : (
            <li className="nav-item">
              <Link className={navLinkClass} style={navLinkStyle} to="/Login">
                Login
              </Link>
            </li>
          )}
        </ul>
      </div>
    </nav>
  )
}

export default Header
